import React from 'react'

import nps from '../assets/npsexplainer.svg'

const NPSExplainer = () => (
    <div className="pp-slide-layout-container" style={{ height: '100%' }}>
        <div className="pp-summary-slide-content" style={{ height: 'calc(100% - 60px)' }}>
            <img src={nps} alt="nps-explainer" style={{ width: '100%', height: '100%' }} />
        </div>
    </div>
)

export default NPSExplainer
